import { formatTimestampAsMinutesSeconds } from '@shared/utils/timeUtils';
import * as SCORING_TAG from '@js/constants/scoring-tags';

const properties = [
	'id',
	'name',
	'event',
	'tag',
	'timestamp',
	'originalTimestamp',
	'value',
	'secondsBefore',
	'secondsAfter',
	'rating',
	'imageUrl',
	'team',
	'teamId',
	'player',
	'playerId',
	'url',
	'taggingToolOnly',
	'priority',
	'labelType',
	'timeline',
	'likes',
	'data',
	'gameTimeSeconds',
	'tagTemplateItem',
	'scoreHome',
	'scoreGuest',
	'score',
	'scoreIntensity',
	'iqScore',
];

class EventTag {
	id = null;
	name = null;
	event = null;
	tag = null;
	timestamp = null;
	originalTimestamp = null;
	value = null;
	secondsBefore = null;
	secondsAfter = null;
	rating = null;
	imageUrl = null;
	team = null;
	player = null;
	teamId = null;
	playerId = null;
	taggingToolOnly = false;
	timeline = false;
	likes = 0;
	data = null;
	processed = false;
	offsetRelevant = false;
	gameTimeSeconds = null;
	tagTemplateItem = null;
	scoreHome = null;
	scoreGuest = null;
	score = null;
	scoreIntensity = 0;
	iqScore = null;

	constructor(props, options = {}) {
		for (const key of properties) {
			if (key in props) {
				if (key === 'timeline') {
					// set timeline to true if timeline is enabled, otherwise check if the tag is in the showTags array
					// showTags is set via URL parameter showTag (one parame per tag name, e.g. 'cut')
					this[key] = props[key] || (options.showTags && options.showTags.includes(props.tag.name));
				} if (key === 'likes' && props.likes === null) {
					this[key] = 0;
				} else {
					this[key] = props[key];
				}
			}
		}

		if (this.score && this.score > 0) {
			this.scoreIntensity = Math.floor((this.score - 1) / 10) + 1;
		}
	}

	get duration() {
		const duration = this.secondsBefore + this.secondsAfter;
		if (!Number.isFinite(duration)) {
			return 0;
		}
		return duration;
	}

	get time() {
		// TODO: added this getter to cope with Timeline.vue that generally uses `time` prop instead of `timestamp`
		return this.timestamp;
	}

	get startTimestamp() {
		return this.timestamp - this.secondsBefore;
	}

	get endTimestamp() {
		return this.timestamp + this.secondsAfter;
	}

	get formattedTimestamp() {
		return formatTimestampAsMinutesSeconds(this.timestamp);
	}

	get formattedDuration() {
		return `${this.duration}s`;
	}

	get teamName() {
		if (!this.team) {
			// throw new Error("Failed to get team name, event has no team attached.");
			return null;
		}
		return this.team.name;
	}

	get playerName() {
		return this.player?.name;
	}

	get isVisibleInTimeline() {
		return this.tag.timeline;
	}

	get participantName() {
		if (this.team) {
			let teamName = this.team?.club?.code;
			teamName = teamName ?? (this.team.name || '');
			return teamName;
		}

		return this.player?.name;
	}

	get shareLinks() {
		return {
			facebook: `https://www.facebook.com/sharer/sharer.php?u=${this.url}`,
			twitter:  `https://twitter.com/intent/tweet?text=${this.url}`,
			whatsapp: `https://web.whatsapp.com/send?text=${this.url}`,
			mail:     `mailto:?body=${this.url}`,
		};
	}

	get isOutsideVideo() {
		return this.timestamp < 0;
	}

	get isScoringTag() {
		return Object.values(SCORING_TAG).includes(this.tag?.name) ?? false;
	}
}

export default EventTag;
